import { Fragment, useState } from 'react'
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  // Collapse,
  Divider,
  // IconButton,
  // styled,
  Typography
} from '@mui/material'
import {
  formatter
  // getSizesByColor,
  // getQuantityByProduct,
} from '../../utils/auxFunc'

// const ExpandMore = styled((props) => {
// 	const { expand, ...other } = props;
// 	return <IconButton {...other} />;
// })(({ theme, expand }) => ({
// 	transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
// 	padding: "0 0.5rem",
// 	transition: theme.transitions.create("transform", {
// 		duration: theme.transitions.duration.shortest,
// 	}),
// }));

const ProductsDetailOrder = ({ product }) => {
  const [expanded, setExpanded] = useState(false)

  // const sizeAndQuantityByColor = getSizesByColor(product?.product);

  // const quantity = getQuantityByProduct(sizeAndQuantityByColor);

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }
  return (
    <Fragment>
      <Divider />
      <Box display="flex" justifyContent="space-between" width="100%" my={2}>
        <Box display="flex" flexDirection="column" alignItems="start">
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem',
              textTransform: 'capitalize'
            }}
          >
            {product?.product.name}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem',
              textTransform: 'capitalize'
            }}
          >
            {product?.product.sku !== '867' && `SKU: ${product?.product.sku}`}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem',
              textTransform: 'capitalize'
            }}
          >
            {product?.descriptionColor && `Color: ${product?.descriptionColor}`}
          </Typography>
          <Box
            onClick={handleExpandClick}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                color: (theme) => theme.palette.light.main,
                fontSize: '1rem',
                lineHeight: 1.25,
                textTransform: 'capitalize'
              }}
              color="secondary"
            >
              {product.quantity > 1
                ? `${product.quantity} Artículos`
                : `${product.quantity} Artículo`}
            </Typography>
            {/* <ExpandMore
							expand={expanded}
							aria-expanded={expanded}
							aria-label="detalle artículos"
						>
							<ExpandMoreIcon />
						</ExpandMore> */}
          </Box>
        </Box>
        <Box textAlign="right">
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem'
            }}
          >
            {formatter().format(
              product.quantity * product.price * product.dolarValue
            )}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: '1rem',
              color: (theme) => theme.palette.light.main
            }}
          ></Typography>
        </Box>
      </Box>
      {/* <Collapse
				in={expanded}
				timeout="auto"
				unmountOnExit
				sx={{ width: "100%", marginTop: "0.5rem", marginBottom: "1rem" }}
			>
				{sizeAndQuantityByColor?.map((color, index) => (
					<Box key={index} display="flex">
						<Typography
							variant="subtitle2"
							width="15vw"
							mr={2}
							sx={{
								color: (theme) => theme.palette.light.main,
								fontSize: "1rem",
								textTransform: "capitalize",
							}}
						>
							{color.color}
						</Typography>
						{color.types.map((type, index) => (
							<Typography
								key={index}
								variant="subtitle2"
								width="10vw"
								mr={2}
								sx={{
									textAlign: "center",
									fontSize: "1rem",
									color: (theme) => theme.palette.light.main,
								}}
							>
								{type.quantity}
								{type.size}
							</Typography>
						))}
					</Box>
				))}
			</Collapse> */}
    </Fragment>
  )
}

export default ProductsDetailOrder
